var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapShow3D"},[_c('div',{staticClass:"cesiumContainer",attrs:{"id":"cesiumContainer"}}),_c('popupcom',{attrs:{"popupinfo":_vm.popupinfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }